/*
  Replays the jQuery calls that inline scripts made before the deferred jquery.js arrived
  (see the stand-in $ in layout/theme.liquid). Must load right after jquery.js, both deferred.

  The replay waits for DOMContentLoaded, which fires only after every deferred script has run.
  A deferred jQuery treats the page as ready at once and would otherwise fire the queued
  $(document).ready callbacks before swiper.js and the other deferred scripts they rely on.
  With jquery.js in the head, those callbacks always ran at DOMContentLoaded too.
*/
(function () {
  var queue = window.gsJQueryQueue;
  if (!queue || !window.jQuery) return;
  window.gsJQueryQueue = null;

  function replay() {
    queue.forEach(function (call) {
      try {
        var result = window.jQuery.apply(window, call.args);
        call.chain.forEach(function (step) {
          result = result[step[0]].apply(result, step[1]);
        });
      } catch (error) {
        console.error('jquery-queue: could not replay a queued jQuery call', error);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', replay);
})();
